import { FC, ReactNode } from 'react'
import { Radio } from 'antd'

interface ClearableRadioOption {
    value: string | number
    label: ReactNode
}

interface ClearableRadioGroupProps {
    value?: string | number
    onChange?: (value: string | number | undefined) => void
    options: ClearableRadioOption[]
    disabled?: boolean
}

const ClearableRadioGroup: FC<ClearableRadioGroupProps> = ({
    value,
    onChange,
    options,
    disabled,
}) => {
    return (
        <Radio.Group
            style={{ display: 'flex', justifyContent: 'space-between' }}
            value={value}
            disabled={disabled}
            onChange={e => {
                const newValue = e.target.value as string | number
                onChange?.(newValue)
            }}
        >
            {options.map(option => (
                <Radio
                    key={option.value}
                    value={option.value}
                    onClick={e => {
                        if (disabled) return
                        if (value === option.value) {
                            e.preventDefault()
                            onChange?.(undefined)
                        }
                    }}
                >
                    {option.label}
                </Radio>
            ))}
        </Radio.Group>
    )
}

export default ClearableRadioGroup



